import type { BaseIconProps } from "@/assets/icons/geist/utils";
import type { FC } from "react";

export const IconChartNoAxesCombined: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    className={className}
                    {...props}
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8 10.2222V13"
                        stroke="currentColor"
                        strokeWidth="1.11111"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M10.2222 9.1111V13"
                        stroke="currentColor"
                        strokeWidth="1.11111"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M12.4444 6.8889V13"
                        stroke="currentColor"
                        strokeWidth="1.11111"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M13.5556 3L8.7522 7.8033C8.7264 7.8292 8.6957 7.8497 8.662 7.8637C8.6283 7.8777 8.5921 7.8849 8.5556 7.8849C8.519 7.8849 8.4828 7.8777 8.4491 7.8637C8.4154 7.8497 8.3847 7.8292 8.3589 7.8033L6.5300 5.9744C6.4779 5.9224 6.4072 5.8931 6.3336 5.8931C6.2599 5.8931 6.1893 5.9224 6.1372 5.9744L2.4444 9.6667"
                        stroke="currentColor"
                        strokeWidth="1.11111"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M3.5556 11.3333V13"
                        stroke="currentColor"
                        strokeWidth="1.11111"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M5.7778 9.1111V13"
                        stroke="currentColor"
                        strokeWidth="1.11111"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M10 12.7778V16.25"
                        stroke="currentColor"
                        strokeWidth="1.38889"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M12.7778 11.3889V16.25"
                        stroke="currentColor"
                        strokeWidth="1.38889"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M15.5556 8.6111V16.25"
                        stroke="currentColor"
                        strokeWidth="1.38889"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M16.9444 3.75L10.9402 9.7542C10.908 9.7865 10.8697 9.8121 10.8275 9.8297C10.7853 9.8472 10.7401 9.8563 10.6944 9.8563C10.6488 9.8563 10.6035 9.8472 10.5613 9.8297C10.5191 9.8121 10.4808 9.7865 10.4486 9.7542L8.1625 7.4681C8.0946 7.4003 8.0072 7.3639 7.9169 7.3639C7.8266 7.3639 7.7391 7.4003 7.6714 7.4681L3.0556 12.0833"
                        stroke="currentColor"
                        strokeWidth="1.38889"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M4.4444 14.1667V16.25"
                        stroke="currentColor"
                        strokeWidth="1.38889"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M7.2222 11.3889V16.25"
                        stroke="currentColor"
                        strokeWidth="1.38889"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case "lg":
            return (
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    className={className}
                    {...props}
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 15.3333V19.5"
                        stroke="currentColor"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M15.3333 13.6667V19.5"
                        stroke="currentColor"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M18.6667 10.3333V19.5"
                        stroke="currentColor"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M20.3333 4.5L13.1283 11.705C13.0896 11.7438 13.0436 11.7746 12.993 11.7956C12.9424 11.8166 12.8881 11.8274 12.8333 11.8274C12.7785 11.8274 12.7242 11.8166 12.6736 11.7956C12.623 11.7746 12.577 11.7438 12.5383 11.705L9.79496 8.96167C9.71682 8.88355 9.61086 8.83967 9.50038 8.83967C9.38989 8.83967 9.28393 8.88355 9.20579 8.96167L3.66663 14.5"
                        stroke="currentColor"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M5.33337 17V19.5"
                        stroke="currentColor"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M8.66663 13.6667V19.5"
                        stroke="currentColor"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
    }
};
